import{post } from '@/utils/request';
import{filerequesturl } from '@/utils/baseUrl';


export async function getMDataMessage(param) {
    return post('/mdataserver/masterData/getMDataMessage',param,true)
}
export const filerequest_url=filerequesturl;
export async function getEditMessage(param) {
    return post('/mdataserver/masterData/getEditMessage',param,true)
}
export async function replaceMasterData(param) {
    return post('/mdataserver/masterData/replaceMasterData',param,true)
}
export async function saveMDRelation(param) {
    return post('/mdataserver/masterData/saveMDRelation',param,true)
}